import Text from 'components/Formik/Text';

const AHPRAnumber = ({ initialValues, label }) => {
    initialValues.RegistrationNumber = '';
    return (
        <Text
            label={label}
            name="RegistrationNumber"
            type="tel"
            helper="For Australian physician only"
        />
    );
};

export default AHPRAnumber;
